import { render } from "./GeneralInformationTab.vue?vue&type=template&id=589a0fe3&scoped=true"
import script from "./GeneralInformationTab.vue?vue&type=script&lang=js"
export * from "./GeneralInformationTab.vue?vue&type=script&lang=js"

import "./GeneralInformationTab.vue?vue&type=style&index=0&id=589a0fe3&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589a0fe3"]])

export default __exports__